import React from "react";
import classes from "./Login.module.scss";
import { Button, Divider } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Flow, Google } from "../../../lib/images/logos";
import Showcase from "./Showcase";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const LoginView = ({ onSignInClick, onSignupClick }) => {
  return (
    <div className={classes.login}>
      <div className={classes.header}>
        <div className={classes.logoContainer}>
          <a href="https://nanonets.com/flow/home">
            <Flow title="Flow by Nanonets" />
          </a>
        </div>
      </div>
      <div className={classes.background}>
        <img src="/login.svg" alt="" />
      </div>
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.loginBox}>
            <div className={classes.loginBoxContent}>
              <div className={classes.title}>
                Get started with a Free Trial today!
              </div>
              <div>
                <Button
                  className={classes.google}
                  sx={{height: "46px"}}
                  variant="contained"
                  color="primary"
                  disableElevation={false}
                  fullWidth
                  onClick={onSignupClick}
                  startIcon={<EmailOutlinedIcon sx={{ml: 1, width: 20, height: 20}}/>}
                  endIcon=""
                >
                  <span>
                    Start your 7-day trial with your work email
                  </span>
                  <div/>
                </Button>
              </div>
              <div className={classes.seperator}>
                <Divider />
                Or
                <Divider />
              </div>
              <div className={classes.register}>
                <Button
                  variant="contained"
                  disableElevation={false}
                  fullWidth
                  startIcon={<Google />}
                  onClick={onSignupClick}
                >
                  <span>
                    Sign up with Google <ArrowForwardIcon />
                  </span>
                  <span />
                </Button>
                <div className={classes.terms}>
                  <span>By signing up, you agree to Nanonets' </span>
                  <a
                    href="https://legal.nanonets.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </a>
                  <span> and </span>
                  <a
                    href="https://legal.nanonets.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
              <div className={classes.signin}>
                Already have an account?{" "}
                <Button size="small" onClick={onSignInClick}>
                  Sign in
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className={classes.banner}>
            <a href="https://nanonets.com/flow/home">
              Your accounts payable, simplified.
            </a>
          </div>
          <div className={classes.showcase}>
            <Showcase />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginView;
